module.exports = __webpack_public_path__ + "img/empreendimento-logo-7.251bb25c.png";